import script from "./QueryHistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryHistoryView.vue?vue&type=script&setup=true&lang=js"

import "./QueryHistoryView.vue?vue&type=style&index=0&id=55e0807c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e0807c"]])

export default __exports__